import * as React from "react";

import { Textarea as ShadcnTextarea } from "src/shadcn/components/textarea";

const Textarea = React.forwardRef<
  React.ElementRef<typeof ShadcnTextarea>,
  React.ComponentProps<typeof ShadcnTextarea>
>((props, ref) => <ShadcnTextarea ref={ref} {...props} />);

Textarea.displayName = "Textarea";

export { Textarea };
